import { render, staticRenderFns } from "./VlCardHeader.vue?vue&type=template&id=3e646f54&scoped=true&"
import script from "./VlCardHeader.vue?vue&type=script&lang=js&"
export * from "./VlCardHeader.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3e646f54",
  null
  
)

export default component.exports